import { ModalWindow } from '@cian/ui-kit';

import { type FC, useCallback } from 'react';
import { useSelector } from 'react-redux';

import { useReduxDispatch } from '@/packages/redux-state/store';
import { complaintsActions } from '@/packages/redux-state/store/slices/complaints/complaintsSlice';
import { selectComplaintsModalOpened } from '@/packages/redux-state/store/slices/complaints/selectors/selectComplaintsModalOpened';

import { ComplaintModalContent } from './components/ComplaintModalContent';

export const ComplaintFlowContainer: FC = () => {
  const dispatch = useReduxDispatch();
  const isModalOpen = useSelector(selectComplaintsModalOpened);
  const onModalClose = useCallback(() => dispatch(complaintsActions.closeModal()), [dispatch]);

  return (
    <ModalWindow
      content={isModalOpen && <ComplaintModalContent onClose={onModalClose} />}
      open={isModalOpen}
      size="XS"
      width={600}
      onClose={onModalClose}
    />
  );
};
